import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import tournamentActions from '../actions/sponsorTournament'

export const useTournament = () => {
  const data = useSelector((state) => {
    return get(state, 'app.tournamentManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(tournamentActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
